import React, { useState } from 'react';
import './CheckboxField.css';
import Field from './Field';

export function CheckboxField(props) {
  const { onCheck, text } = props;
  const [checked, setChecked] = useState(false);
  const checkedClassName = checked ? 'checked' : '';

  const handleClick = (e) => {
    e.preventDefault();
    setChecked(!checked);
    onCheck(text);
  };

  return (
    <Field {...props}>
      <li>
        <button
          className={`customCheckboxListItem ${checkedClassName}`}
          aria-label={text}
          onClick={(e) => handleClick(e)}
        >
          {text}
        </button>
      </li>
    </Field>
  );
}
